<div class="xr-page">
  <header class="xr-page-header">
    <div>
      <h1 class="xr-page-title">{{ 'rooms_list.title' | translate }}</h1>
    </div>
    <div class="rooms-toolbar">
    <app-company-filter></app-company-filter>
    @if (!onlyCalls) {
    <div class="xr-filters" role="group" [attr.aria-label]="'rooms_list.filter_label' | translate">
      @for (item of filters; track item.id) {
        <button
          type="button"
          class="xr-filter"
          [class.active]="filter === item.id"
          [attr.aria-pressed]="filter === item.id"
          (click)="filter = item.id"
        >
          {{ item.label | translate }} <span class="rooms-filter-count">{{ countFor(item.id) }}</span>
        </button>
      }
    </div>
    }
    </div>
  </header>
  @if (onlyCalls) {
    <p class="rooms-calls-hint">{{ 'rooms_list.calls_hint' | translate }}</p>
  }

  <section class="xr-grid" [attr.aria-label]="'rooms_list.list_label' | translate" aria-live="polite">
    @for (room of filteredRooms; track room.id) {
      <app-item-room [room]="room"></app-item-room>
    }
  </section>

  @if (loaded && !filteredRooms.length) {
    <div class="xr-empty">
      {{ (onlyCalls ? 'rooms_list.empty_calls' : companyRooms.length ? 'rooms_list.empty_filter' : (listRooms.length ? 'company_filter.empty' : 'rooms_list.empty')) | translate }}
    </div>
  }
</div>
